export default "__VITE_ASSET__D9JXbsr3__"